/**
 * Resolve um caminho ('bill.contact.name') dentro da linha exportada, do mesmo
 * jeito que os exportadores resolvem `col.key` quando a coluna não tem `format`.
 */
export function getRowValue(row: Record<string, any>, path: string): any {
  let value: Record<string, any> | undefined = row;
  for (const key of path.split('.')) {
    value = value?.[key] as Record<string, any> | undefined;
  }
  return value;
}
